import './globals';
import {Dropdown} from "bootstrap";

/**
 * Initialize Select fields
 */
(function ($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function () {
        // hide dropdown if another place is clicked
        document.addEventListener('click', (e) => {
            const target = e.target.closest('.bootstrap-select');

            const selectDropdowns = document.querySelectorAll('.bootstrap-select.show');
            selectDropdowns.forEach((dropdownEl) => {
                if (dropdownEl !== target) {
                    const dropdown = Dropdown.getOrCreateInstance(dropdownEl);

                    dropdown.hide();
                }
            })
        }, {passive: true});
    });
})(jQuery, window, document, window.PageLoadedQueue);
